import { Box, Button, Container, Typography } from "@mui/material";
import React from "react";
// import "./OneYearProgramPCM.css";
import "../styles/LandingPagesStyles/OneYearProgramPCM.css";


import footerText from "../assets/images/one-year-program-pcm/footer circleArrowImage.png";
import footerRightsideText from "../assets/images/one-year-program-pcm/Footer Right side Text image.png";

import heroName from "../assets/images/one-year-program-pcm/HeroSectionNameImage.png";
import heroStudent from "../assets/images/one-year-program-pcm/HeroSectionStudentImage.png";
import heroTarget from "../assets/images/one-year-program-pcm/HeroSectionTargetImage.png";
import middleMobile from "../assets/images/one-year-program-pcm/middle section Mobile Image.png";

import { useNavigate, useParams } from "react-router-dom";
import avoidSillyMistakes from "../assets/images/one-year-program-pcm/avoid_silly_mistakes_icon.png";
import detailedPerformanceReports from "../assets/images/one-year-program-pcm/detailed_performance_reports_icon.png";
import flexibleConvenient from "../assets/images/one-year-program-pcm/flexible_convenient_icon.png";
import focusOnWeakAreas from "../assets/images/one-year-program-pcm/focus_on_weak_areas_icon.png";
import realExamPatternIcon from "../assets/images/one-year-program-pcm/real_exam_pattern_icon.png";
import { Footer } from "../MarketingSiteComponents/Footer";
import { Header } from "../MarketingSiteComponents/Header";
import cardTemplateDescriptionsData from '../staticDataTemplate.json';
import demoCardTemplateDescriptions from '../staticDataTemplateDemoServer.json';

const features = [
    {
        title: "Real Exam\nPattern",
        image: realExamPatternIcon,
    },
    {
        title: "Detailed\nPerformance Reports",
        image: detailedPerformanceReports,
    },
    {
        title: "150+ Chapter‑wise Tests, 50+ FSTs & 50+ PYQs",
        image: flexibleConvenient,
    },
    {
        title: "Focus on\nWeak Areas",
        image: focusOnWeakAreas,
    },
    {
        title: "Avoid\nSilly Mistakes",
        image: avoidSillyMistakes,
    },
];


const testimonials = [
    {
        name: "Rohit Patil",
        role: "MHT-CET 2026 Aspirant",
        avatar: "R",
        quote:
            "Test series has really helped me identify my weak topics. The detailed analysis makes improvement easy.",
    },
    {
        name: "Sneha Deshpande",
        role: "JEE Main 2026 Aspirant",
        avatar: "S",
        quote:
            "Mock tests are very close to the real exam. Performance reports help me plan my preparation better.",
    },
    {
        name: "Ajit Singh",
        role: "Parent",
        avatar: "A",
        quote:
            "The test series provides clear insights into my child's progress. Highly recommended!",
    },
    {
        name: "Priya Sheth",
        role: "Parent",
        avatar: "P",
        quote:
            "Medineer.AI's test series is well-structured and easy to use. My child can practice anytime, anywhere.",
    },
];

const scrollToSubscription = () => {
    document
        .getElementById("pcm-subscription")
        ?.scrollIntoView({
            behavior: "smooth",
            block: "center",
        });
};
const isProduction = window.location.origin === "https://www.medineer.ai" || window.location.origin === "https://medineer.ai" ? true : false;
const cardTemplateDescriptions = isProduction ? cardTemplateDescriptionsData : demoCardTemplateDescriptions

const OneYearProgramPCM = () => {
    const navigate = useNavigate();
    const { referralCode } = useParams();

    const handleSubscribe = () => {
        let series = cardTemplateDescriptions.dedicatedPagesofTS[0]
        console.log("series log:", series);

        navigate("/medineer/SignUp", {
            state: {
                series,
                ResourceTypeId: 3,
                referralCode,
            },
        });
    };
    return (
        <Box className="pcm-page">

            {/* =====================================================
          HEADER
      ===================================================== */}
            <header className="pcm-header">
                <Header isHideOptions={true} isfromTSPage={true} />
            </header>


            {/* =====================================================
          HERO SECTION
      ===================================================== */}
            <section className="pcm-hero">

                <div className="pcm-hero-bg" />

                <Container
                    maxWidth={false}
                    className="pcm-hero-inner"
                >

                    {/* LEFT CONTENT */}
                    <div className="pcm-hero-copy">

                        <Typography className="pcm-kickers">
                            MHT-CET / JEE Main 2027
                        </Typography>

                        <Typography
                            component="h1"
                            className="pcm-hero-titles"
                        >
                            Take the Right Steps
                            <br />
                            with Our
                            <br />
                            <span>Test Series</span>
                        </Typography>

                        <Typography className="pcm-hero-subtitles">
                            Real Exam Experience. Better Practice.
                            <br />
                            Higher Confidence.
                        </Typography>


                        {/* HERO FEATURES */}
                        <div className="pcm-hero-benefits">

                            {/* Feature 1 */}
                            <div className="pcm-benefit">

                                <div className="pcm-round-icon">
                                    ✓
                                </div>

                                <div>
                                    <b>
                                        Chapter-wise &
                                        <br />

                                        Full Syllabus Tests
                                    </b>
                                    {/* 
                                    <br />

                                    <small>
                                        <span style={{ color: "#ffd326", fontWeight: '900' }}> ✓</span> 50+ FSTs
                                    </small> */}
                                </div>

                            </div>


                            <div className="pcm-benefit-divider" />


                            {/* Feature 2 */}
                            <div className="pcm-benefit">

                                <div className="pcm-round-icon">
                                    ▥
                                </div>

                                <div>
                                    <b>
                                        Detailed
                                        <br />
                                        Performance Reports
                                    </b>
                                </div>

                            </div>


                            <div className="pcm-benefit-divider" />


                            {/* Feature 3 */}
                            <div className="pcm-benefit">

                                <div className="pcm-round-icon">
                                    📊
                                </div>

                                <div>
                                    <b>
                                        AI-Powered
                                        <br />
                                        Insights
                                    </b>
                                </div>

                            </div>

                        </div>


                        {/* HERO CTA */}
                        <div className="pcm-hero-cta-row">

                            <Button
                                className="pcm-yellow-btn"
                                // onClick={scrollToSubscription}
                                onClick={handleSubscribe}
                            >
                                Subscribe @ Rs 2500/-
                                <span>→</span>
                            </Button>

                            <Typography className="pcm-hero-cta-note">
                                Build Your Exam Readiness Today!
                            </Typography>

                        </div>

                    </div>


                    {/* HERO IMAGES */}
                    <div className="pcm-hero-art">

                        <img
                            src={heroStudent}
                            alt=""
                            className="pcm-studenthero"
                        />
                        {/* <img
                            src={heroLaptop}
                            alt=""
                            className="pcm-laptop"
                        /> */}

                        <img
                            src={heroName}
                            alt=""
                            className="pcm-name-art"
                        />

                        <img
                            src={heroTarget}
                            alt=""
                            className="pcm-target-art"
                        />

                    </div>

                </Container>

            </section>


            {/* =====================================================
          WHY CHOOSE MEDINEER
      ===================================================== */}
            <section className="pcm-why">

                <Container maxWidth="xl">

                    <div className="pcm-section-heading">

                        <span />

                        <Typography component="h2">
                            Why Choose MEDINEER.AI Test Series?
                        </Typography>

                        <span />

                    </div>


                    <Typography className="pcm-section-subtitle">
                        Smart tests. Deeper insights. Better results.
                    </Typography>


                    {/* FEATURES */}
                    <div className="pcm-feature-grids">

                        {features.map((feature) => (

                            <div
                                className="pcm-feature-card"
                                key={feature.title}
                            >

                                <div className="pcm-feature-image-wrap">

                                    <img
                                        src={feature.image}
                                        alt={feature.title}
                                    />

                                </div>


                                <Typography className="pcm-feature-title">

                                    {feature.title
                                        .split("\n")
                                        .map((line, index) => (
                                            <React.Fragment key={index}>
                                                {line}

                                                <br />
                                            </React.Fragment>
                                        ))}

                                </Typography>

                            </div>

                        ))}

                    </div>

                </Container>

            </section>


            {/* =====================================================
          SUBSCRIPTION SECTION
      ===================================================== */}
            <section
                id="pcm-subscription"
                className="pcm-subscription"
            >

                <div className="pcm-middle-bg" />


                <Container
                    maxWidth={false}
                    className="pcm-subscription-inner"
                >

                    {/* LEFT CONTENT */}
                    <div className="pcm-subscription-copy">

                        <Typography className="pcm-small-heading">
                            TEST SERIES
                        </Typography>


                        <Typography
                            component="h2"
                        >
                            Affordable. Effective.
                            <br />
                            Result Oriented.
                        </Typography>


                        <Typography>
                            Premium test series designed specifically
                            <br />
                            for 12th students targeting Engineering exams for 2027.
                        </Typography>

                    </div>


                    {/* PRICE CARD */}
                    <div className="pcm-price-card">

                        <div className="pcm-price-card-title">
                            Test Series Subscription
                        </div>


                        <div className="pcm-price">

                            ₹2500

                            <small>
                                / for 6 months
                            </small>

                        </div>


                        <div className="pcm-price-line" />


                        <ul>

                            <li>
                                All India & State Level Tests
                            </li>

                            <li>
                                Detailed Performance Reports
                            </li>

                            <li>
                                AI Based Analysis
                            </li>

                            <li>
                                Access on Mobile & Web
                            </li>

                        </ul>


                        <Button
                            className="pcm-yellow-btn"
                            onClick={handleSubscribe}
                        >
                            Subscribe Now
                            <span>→</span>
                        </Button>

                    </div>


                    {/* MOBILE IMAGE */}
                    <div className="pcm-mobile-art">
                        <img
                            src={middleMobile}
                            alt="Test analysis on mobile"
                        />


                    </div>

                </Container>

            </section>


            {/* =====================================================
          TESTIMONIALS
      ===================================================== */}
            <section className="pcm-testimonials">

                <Container maxWidth="xl">

                    <div className="pcm-section-heading">

                        <span />

                        <Typography component="h2">
                            What Students & Parents Say
                        </Typography>

                        <span />

                    </div>


                    <Typography className="pcm-section-subtitle">
                        Real stories. Real progress.
                    </Typography>


                    <div className="pcm-testimonial-grid">

                        {testimonials.map((item) => (

                            <div
                                className="pcm-testimonial-card"
                                key={item.name}
                            >

                                <div className="pcm-person">

                                    <div className="pcm-avatar">
                                        {item.avatar}
                                    </div>

                                    <div>

                                        <b>
                                            {item.name}
                                        </b>

                                        <small>
                                            {item.role}
                                        </small>

                                    </div>

                                </div>


                                <Typography className="pcm-quote">
                                    “{item.quote}”
                                </Typography>


                                <div className="pcm-stars">
                                    ★ ★ ★ ★ ★
                                </div>

                            </div>

                        ))}

                    </div>

                </Container>

            </section>


            {/* =====================================================
          BOTTOM CTA
      ===================================================== */}
            <section className="pcm-bottom-cta">

                <Container
                    maxWidth="xl"
                    className="pcm-bottom-cta-inner"
                >
                    {/* left */}
                    <div className="pcm-target-circle">
                        <img
                            src={footerText}
                            alt=""
                            className="pcm-footer-text-art"
                        />
                    </div>

                    {/* middle left */}
                    <div className="pcm-bottom-copy">

                        <Typography className="pcm-bottom-small">
                            Your Dream College is Closer Than You Think!
                        </Typography>


                        <Typography component="h2">
                            Start Your Test Series Today
                        </Typography>


                        <Typography>
                            Practice. Analyze. Improve.
                            &nbsp; | &nbsp;
                            MHT-CET / JEE Main 2027
                        </Typography>

                    </div>

                    {/* middle right */}
                    <Button
                        className="pcm-yellow-btn"
                        onClick={handleSubscribe}
                    >
                        Subscribe @ Rs 2500/-
                        <span>→</span>
                    </Button>

                    {/* right image */}
                    <img
                        src={footerRightsideText}
                        alt=""
                        className="pcm-footer-text-art"
                    />


                </Container>

            </section>


            {/* =====================================================
          FOOTER
      ===================================================== */}
            <Footer isHideOptions={true} />

        </Box>
    );
};

export default OneYearProgramPCM;